var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.734948 18.3429C0.734948 18.8803 0.920948 19.3349 1.29295 19.7069C1.66495 20.0789 2.12995 20.2753 2.68795 20.2959H18.3119C18.8493 20.2959 19.3143 20.0996 19.7069 19.7069C20.0996 19.3143 20.2856 18.8596 20.2649 18.3429V2.68795C20.2649 2.15061 20.0789 1.68561 19.7069 1.29295C19.3349 0.900282 18.8699 0.714282 18.3119 0.734948H2.68795C2.15061 0.734948 1.68561 0.920948 1.29295 1.29295C0.900282 1.66495 0.714282 2.12995 0.734948 2.68795V18.3429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStop);
export default __webpack_public_path__ + "static/media/icon-stop.6973069c82db5ad6efce300794bbdd8c.svg";
export { ForwardRef as ReactComponent };